import React, { useEffect, useState } from "react";
import { Button, FormGroup, Input, Label } from "reactstrap";
import { toast } from "react-toastify";
import { adminInstance } from "../../config/axios";

const LiveDropsBets = () => {
  const [isRunning, setIsRunning] = useState(false);
  const [multiplier, setMultiplier] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const getEngineStatus = async () => {
    try {
      const response = await adminInstance().get(
        "/api/admin/live-drop-engine-status"
      );
      const { data } = response.data || {};

      setIsRunning(Boolean(data?.isRunning));
      setMultiplier(Number(data?.multiplier || 1));
    } catch (error) {
      console.log("Error fetching live drop status", error);
    }
  };

  useEffect(() => {
    getEngineStatus();
  }, []);

  const handleStart = async () => {
    try {
      if (isSubmitting) return;
      if (Number(multiplier) < 1) {
        toast.error("Multiplier must be at least 1");
        return;
      }

      setIsSubmitting(true);
      const response = await adminInstance().post("/api/admin/live-drop-start", {
        multiplier: Number(multiplier),
      });

      if (response?.data?.code === 200) {
        toast.success("Fake live drops started");
        setIsRunning(true);
      }
    } catch (error) {
      toast.error(error?.response?.data?.msg || "Unable to start engine");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleStop = async () => {
    try {
      if (isSubmitting) return;

      setIsSubmitting(true);
      const response = await adminInstance().post("/api/admin/live-drop-stop");

      if (response?.data?.code === 200) {
        toast.success("Fake live drops stopped");
        setIsRunning(false);
        setMultiplier(1);
      }
    } catch (error) {
      toast.error(error?.response?.data?.msg || "Unable to stop engine");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="account-setting">
      <h5 className="f-w-600 f-16 mb-4">Live Drops</h5>

      <FormGroup className="row align-items-center">
        <Label className="col-md-3 col-form-label">Engine Status</Label>
        <div className="col-md-9">
          <span
            className={`badge ${isRunning ? "badge-success" : "badge-danger"}`}
          >
            {isRunning ? "RUNNING" : "STOPPED"}
          </span>
        </div>
      </FormGroup>

      <FormGroup className="row align-items-center">
        <Label className="col-md-3 col-form-label">Multiplier</Label>
        <div className="col-md-9">
          <Input
            type="number"
            min="1"
            step="1"
            value={multiplier}
            onChange={(e) => setMultiplier(e.target.value)}
          />
          <small className="text-muted">
            Example: 1 = 1 sec
          </small>
        </div>
      </FormGroup>

      <div className="d-flex" style={{ gap: "10px" }}>
        <Button
          color="success"
          onClick={handleStart}
          disabled={isSubmitting || isRunning}
        >
          START
        </Button>
        <Button
          color="danger"
          onClick={handleStop}
          disabled={isSubmitting || !isRunning}
        >
          STOP
        </Button>
      </div>
    </div>
  );
};

export default LiveDropsBets;
